import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';

declare interface RouteInfo {
  path: string;
  title: string;
  rtlTitle: string;
  icon: string;
  isAdminOnly: boolean,
}

declare interface ProviderRouteInfo {
  path: string;
  title: string;
  rtlTitle: string;
  icon: string;
  isAdminOnly: boolean,
  isReceptionist: boolean,
  isDoctor: boolean
}


export const ADMIN_ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    rtlTitle: 'لوحة القيادة',
    icon: 'icon-chart-bar-32',
    isAdminOnly: false
  },
  {
    path: '/patients',
    title: 'Patients',
    rtlTitle: 'ملف تعريفي للمستخدم',
    icon: 'icon-badge',
    isAdminOnly: false
  },
  {
    path: '/providers',
    title: 'Providers',
    rtlTitle: 'الشركاء',
    icon: 'icon-bank',
    isAdminOnly: false
  },
  {
    path: '/specialities',
    title: 'Specialities',
    rtlTitle: '',
    icon: 'icon-molecule-40',
    isAdminOnly: false
  },
  {
    path: '/packages',
    title: 'Packages',
    rtlTitle: '',
    icon: 'icon-app',
    isAdminOnly: true
  },
  {
    path: '/orders',
    title: 'Orders',
    rtlTitle: 'خرائط',
    icon: 'icon-cart',
    isAdminOnly: false
  },
  {
    path: '/cms',
    title: 'CMS',
    rtlTitle: 'قائمة الجدول',
    icon: 'icon-components',
    isAdminOnly: false
  },
  {
    path: '/users',
    title: 'Users',
    rtlTitle: 'قائمة الجدول',
    icon: 'icon-single-02',
    isAdminOnly: true
  },
  {
    path: '/groups',
    title: 'Permission Groups',
    rtlTitle: 'قائمة الجدول',
    icon: 'icon-lock-circle',
    isAdminOnly: true
  },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor(private auth: AuthService) {}

  ngOnInit() {
    const user = this.auth.user;
    this.menuItems = ADMIN_ROUTES.filter(menuItem => menuItem);
  }

  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }
}
